module.exports = __webpack_public_path__ + "img/coursespecialty2.6d0cba3a.jpg";